export const CHAR_SIZE = 7;
export const PADDING = 17;
